{
    "common": {
        "mon": "Maan",
        "tue": "Tiis",
        "wed": "Kesk",
        "thu": "Torst",
        "fri": "Perj",
        "sat": "Lau",
        "sun": "Su",
        "jan": "Tammi",
        "feb": "Helmi",
        "mar": "Maalis",
        "apr": "Huhti",
        "jun": "Kesä",
        "jul": "Heinä",
        "aug": "Elo",
        "sep": "Syys",
        "oct": "Loka",
        "nov": "Marras",
        "dec": "Joulu",
        "january": "Tammikuu",
        "february": "Helmikuu",
        "march": "Maaliskuu",
        "april": "Huhtikuu",
        "may": "Toukokuu",
        "june": "Kesäkuu",
        "july": "Heinäkuu",
        "august": "Elokuu",
        "september": "Syyskuu",
        "october": "Lokakuu",
        "november": "Marraskuu",
        "december": "Joulukuu",
        "checkin": "Tarkista-sisään",
        "checkout": "Tarkista-Ulos",
        "room": "Huone",
        "rooms": "Huoneet",
        "adult": "Aikuinen",
        "adults": "Aikuiset",
        "edit": "Muokkaa",
        "editCap": "MUOKKAA",
        "delete": "Poista",
        "deleteCap": "POISTA",
        "localTime": "Paikallinen Aika",
        "back": "TAKAISIN",
        "home": "KOTI",
        "yes": "KYLLÄ",
        "no": "EI",
        "left": "Jäljellä",
        "hour": "Tunti",
        "hours": "Tuntia",
        "night": "yö",
        "nights": "yötä",
        "for": "varten",
        "why": "Miksi",
        "get": "Hanki",
        "more": "Lisää",
        "agree": "HYVÄKSY",
        "disagree": "EN HYVÄKSY",
        "basedOn": "perustuen",
        "error": "Tapahtui virhe, yritä myöhemmin uudelleen",
        "error2": "Epäonnistui, yritä uudelleen!",
        "error3": "Virhe Tapahtui!!",
        "error4": "Tapahtui virhe!! Yritä uudelleen",
        "error5": "Anteeksi!! Tapahtui virhe. Yritä uudelleen hetken kuluttua.",
        "hi": "Hei",
        "to": "kohtaan",
        "free": "Ilmainen",
        "per": "Per",
        "at": "klo",
        "day": "Päivä",
        "days": "Päivää",
        "time": "Aika",
        "of": "ja",
        "photo": "Kuva",
        "photos": "Kuvat",
        "done": "Valmis",
        "fullStay": "Koko Oleskelu",
        "date": "Päivämäärä",
        "and": "ja",
        "bookingDetail": "Varauksen Yksityiskohdat",
        "Back": "Takaisin",
        "Home": "Koti"
    },
    "userPopup": {
        "myAccount": "Tilini",
        "welcome": "Tervetuloa",
        "user": "Käyttäjä",
        "findMyBookings": "LÖYDÄ OMAT VARATAKSET",
        "viewProfile": "NÄYTÄ PROFIILI",
        "makeAReservarion": "TEE VARATAUS",
        "logout": "KIRJAUDU ULOS",
        "loginCap": "KIRJAUDU SISÄÄN",
        "login": "Kirjaudu sisään",
        "invalidCredentials": "Virheelliset kirjautumistiedot",
        "invalidEmail": "Virheellinen sähköposti",
        "passwordIsRequired": "Salasana on pakollinen",
        "minChar8": "vähintään 8 merkkiä",
        "tooShort": "Liian lyhyt!",
        "tooLong": "Liian pitkä!",
        "required": "Pakollinen",
        "emailInvalid": "Syötä kelvollinen sähköposti",
        "passwordInvalid": "Syötä kelvollinen salasana",
        "phNumInvalid": "Puhelinnumero ei ole kelvollinen",
        "signupCap": "REKISTERÖIDY",
        "signup": "Rekisteröidy",
        "verifyText": "Vahvista että olet sinä",
        "verifyText2": "Lähetimme vahvistuskoodin sähköpostiisi",
        "verificationCode": "Vahvistuskoodi",
        "didNotReceiveEmail": "Etkö saanut sähköpostia",
        "clickToResend": "Klikkaa lähettääksesi uudelleen",
        "verifyAndSignIn": "Vahvista ja Kirjaudu sisään",
        "otpSentSuccessfully": "Koodi lähetettiin onnistuneesti",
        "somethingWentWrong": "Jotain meni pieleen, yritä uudelleen",
        "otpError": "Syötä kelvollinen numero",
        "otpError2": "Syötä vain numeroita",
        "otpError3": "Väärä koodi, yritä uudelleen",
        "otpError4": "Koodi vanhentui, klikkaa Lähetä uudelleen yrittääksesi uudelleen",
        "otpError5": "Yritä uudelleen",
        "forgetPassword": "Unohtuiko salasana",
        "submitError": "Käyttäjää ei ole olemassa!",
        "userExistError": "Käyttäjä on jo olemassa",
        "checkYourEmail": "Tarkista sähköpostisi",
        "passwordResetLinkSent": "Lähetimme salasanan vaihtolinkin osoitteeseen",
        "noWorriesResetInstructions": "Ei hätää, lähetämme sinulle resetointiohjeet.",
        "enterYourEmail": "Syötä sähköpostisi",
        "resetMyPassword": "NOLLAA SALASANANI",
        "setANewPassword": "Aseta uusi salasana",
        "newPassword": "Uusi salasana",
        "confirmPassword": "Vahvista salasana",
        "confirmPasswordError": "Salasanojen on täsmättävä",
        "backToLogin": "Takaisin kirjautumiseen",
        "dontHaveAccount": "Eikö sinulla ole tiliä?",
        "alreadyHaveAccount": "Onko sinulla jo tili?",
        "memberDiscount1": "Saat",
        "memberDiscount2": "jäsenen alennusta ikuisesti.",
        "discount1": "Hallinnoi kaikkia varauksiasi yhdestä paikasta.",
        "discount2": "Rekisteröidy henkilökohtaisiin suosituksiin ja räätälöityihin kokemuksiin!!",
        "discount3": "Liity onnellisten vieraiden yhteisöömme ja aloita matkasuunnittelu.",
        "leftGridText1": "Hallinnoi kaikkia varauksiasi yhdestä paikasta",
        "leftGridText2": "Rekisteröidy henkilökohtaisiin suosituksiin ja räätälöityihin kokemuksiin!!",
        "leftGridText3": "Liity onnellisten vieraiden yhteisöömme ja aloita matkasuunnittelu",
        "gridDiscountText1": "jäsenen alennus",
        "gridDiscountText2": "valituissa hotelleissa ikuisesti",
        "gridDiscountText3": "Kirjaudu sisään henkilökohtaiseen kokemukseen ikuisesti",
        "gridDiscountText4": "Hanki Vain Jäsenen Etuoikeudet",
        "findBookingError": "Sähköpostisi ja varausnumerosi eivät täsmää",
        "verifyAndConfirmBooking": "Vahvista ja vahvista varaus",
        "confirmEmailText": "Lähetimme vahvistuskoodin sähköpostiosoitteeseesi",
        "enterCodeText": "Syötä sinulle lähetetty vahvistuskoodi",
        "didNotRecieveEmail": "Etkö saanut sähköpostia?",
        "changeEmailText": "Klikkaa tästä vaihtaaksesi sähköpostiosoitteen",
        "verifyAndConfirm": "Vahvista ja Vahvista",
        "verified": "Vahvistettu",
        "bookingExpired": "Varaus vanhentui",
        "bookingExpiredText": "Olemme pahoillamme, käyttämäsi varausnumero on vanhentunut",
        "backToFindingBooking": "Takaisin varauksen etsimiseen",
        "findMyBooking": "Etsi Omia Varauksiani",
        "bookingEmail": "Varauksen sähköposti",
        "reservationId": "Varausnumero",
        "findBooking": "LÖYDÄ VARAUS",
        "abandonmentCartDoneText1": "Kiitos!",
        "abandonmentCartDoneText2": "Ostoskorin tiedot on lähetetty sähköpostiin. Jatka varaustasi milloin tahansa.",
        "Recommended Currencies": "Suositellut Valuutat",
        "All currencies": "Kaikki valuutat",
        "thisIsRequiredField": "Tämä on pakollinen kenttä"
    },
    "widget": {
        "destination": "Määränpää",
        "enterDestination": "SISÄLLÄ MÄÄRÄNPÄÄ",
        "guests": "Vieraat",
        "guest": "Vieras",
        "nationality": "Kansalaisuus",
        "selectNationality": "Valitse kansalaisuus",
        "nationalityIsRequired": "Kansalaisuus on pakollinen",
        "selectedRate": "Erikoishinta",
        "search": "Hae",
        "ages": "Iät",
        "orAbove": "Tai Ylempänä",
        "child": "Lapsi",
        "children": "Lapset",
        "addAnotherRoom": "Lisää Toinen Huone",
        "removeRoom": "Poista Huone",
        "property": "Hotelli",
        "city": "Kaupunki",
        "country": "Maa",
        "bookNow": "Varaa Nyt",
        "overnightStay": "Yöpyminen",
        "dayUse": "Päiväkäyttö",
        "destinationIsRequired": "Määränpää vaaditaan",
        "checkInIsRequired": "Aloituspäivä vaaditaan",
        "checkOutIsRequired": "Lopetuspäivä vaaditaan",
        "noLocationFound": "Sijaintia Ei Löytynyt",
        "soldOut": "Loppuunmyyty",
        "highDemand": "Korkea Kysyntä",
        "dates": "Päivämäärät",
        "allRates": "Kaikki hinnat ovat",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Samana päivänä uloskirjautuminen"
    },
    "promotion": {
        "headingText": "Tärkeät Tiedot",
        "regularRate": "Ei mitään",
        "seniorCitizen": "Vanhuus- Hintaluokka",
        "agencyRate": "Toimiston Hintaluokka",
        "caaRate": "CAA/AAA Hintaluokka",
        "corporateRate": "Yritys Hintaluokka",
        "governmentRate": "Hallitus/Sotilaallis Hintaluokka",
        "promotionalSpecialRate": "Markkinointi/Erikois Hintaluokka",
        "regularRateDescription": "Kampanjaa ei sovellettu.",
        "seniorCitizenRateDescription": "Tämä on alennettu hotellisuositus, joka on laajasti saatavilla vanhemmille aikuisille, yleensä 60-vuotiaille tai vanhemmille.",
        "agencyRateDescription": "Tämä on alennettu hotellisuositus, joka tarjotaan ja johon pääsee vain tietyillä matkanjärjestäjillä, edistäen kumppanuutta.",
        "caaRateDescription": "Tämä on erityinen hotellisuositus, joka tarjotaan AAA tai CAA -jäsenille yksinoikeuksia säästöjä.",
        "corporateRateDescription": "Tämä on alennettu hotellisuositus, joka jatkuu liikematkailijoille, yleensä neuvoteltu hotellin ja yhtiön välillä.",
        "governmentRateDescription": "Tämä hintasuunnitelma tarjoaa tiettyjä alennuksia Hallitus/Sotilaalliselle henkilöstölle hotellivaraus.",
        "contentSeniorCitizen": "Syntymääjän todiste on pakollinen sisäänkirjautumishetkellä. Asiaankuuluvan henkilötodistuksen toimittaminen johtaa vallitseviin maksuihin.",
        "contentAgencyRate": "Varmista, että sinulla on varauksen vahvistus ja henkilötodistus saapuessasi. Näiden esittämättä jättäminen johtaa standardikursseihin.",
        "contentPromotionalSpecialRate": "Tämä on alennettu hotellisuositus, joka tarjotaan rajoitetulla ajalla, usein yhteydessä tiettyihin tapahtumiin, vuodenajoihin tai markkinointiyrityksiin.",
        "contentCaaRate": "Varmista, että sinulla on CAA -jäsenyyskorttisi tai asiaankuuluva henkilötodistus sisäänkirjautumishetkellä. Asiaankuuluvan henkilötodistuksen toimittaminen johtaa vallitseviin maksuihin.",
        "contentCorporateRate": "Yrityksen henkilötodistusta tai muuta virallista dokumentaatiota vaaditaan sisäänkirjautumishetkellä. Asiaankuuluvan todistuksen toimittaminen johtaa vallitseviin maksuihin.",
        "contentGovernmentRate": "Kelvollinen hallitus tai sotilaallinen henkilötodistus on annettava sisäänkirjautumishetkellä. Vaaditun henkilötodistuksen toimittaminen johtaa veloituksiin vakiokurssilla.",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "SOVELLA",
        "Offer Code": "Tarjouksekoodi",
        "Agency Code": "Toimistokoodi",
        "Corporate Code": "Yrityskoodi",
        "All-Access Rate": "Kaikki-Pääsy Hintaluokka",
        "errorCode": "Tämä Koodi ei ole voimassa"
    }
}

